import { Checkbox as MuiCheckbox, SvgIcon } from '@mui/material';
import { FormControlLabel } from './FormControlLabel';
import type { CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';
import type { SxProps, Theme } from '@mui/material/styles';

export type CheckboxProps = MuiCheckboxProps & { label?: string };

const checkboxSx = {
  '& .MuiSvgIcon-root': {
    fontSize: '1.25rem',
  },
  '&.MuiCheckbox-sizeSmall .MuiSvgIcon-root': {
    fontSize: '1.125rem',
  },
} as const;

const uncheckedIcon = (
  <SvgIcon viewBox="0 0 24 24">
    <rect
      x="3.5"
      y="3.5"
      width="17"
      height="17"
      rx="2.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
  </SvgIcon>
);

const checkedIcon = (
  <SvgIcon viewBox="0 0 24 24">
    <rect x="2.5" y="2.5" width="19" height="19" rx="3" fill="currentColor" />
    <path
      d="m7.5 12.4 3.1 3.1 6.2-6.2"
      fill="none"
      stroke="#ffffff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.75"
    />
  </SvgIcon>
);

const indeterminateIcon = (
  <SvgIcon viewBox="0 0 24 24">
    <rect x="2.5" y="2.5" width="19" height="19" rx="3" fill="currentColor" />
    <path d="M7.5 12h9" fill="none" stroke="#ffffff" strokeLinecap="round" strokeWidth="2.75" />
  </SvgIcon>
);

const mergeCheckboxSx = (sx: SxProps<Theme> | undefined): SxProps<Theme> => {
  if (sx === undefined) {
    return checkboxSx;
  }
  const mergedSx = [checkboxSx, sx] as SxProps<Theme>;
  return mergedSx;
};

export const Checkbox = ({ label, size = 'small', sx, ...rest }: CheckboxProps): JSX.Element => {
  const control = (
    <MuiCheckbox
      checkedIcon={checkedIcon}
      icon={uncheckedIcon}
      indeterminateIcon={indeterminateIcon}
      size={size}
      sx={mergeCheckboxSx(sx)}
      {...rest}
    />
  );

  return label ? <FormControlLabel control={control} label={label} /> : control;
};
